module.exports = __webpack_public_path__ + "static/media/markdown.49c339e4.svg";